import { Flex, Text } from "@chakra-ui/react";
import Features from '../home/components/features';
import SEO from '../components/SEO';
import Breadcrumbs from '../components/Breadcrumbs';
import { useTranslation } from '../i18n/LanguageContext';

export default function FeaturesPage() {
  const { t } = useTranslation();

  const featuresJsonLd = {
    "@type": "WebPage",
    "name": t("seo.features.title"),
    "description": t("seo.features.description"),
    "mainEntity": {
      "@type": "ItemList",
      "itemListElement": [
        { "@type": "ListItem", "position": 1, "name": t("features.slide1.title") },
        { "@type": "ListItem", "position": 2, "name": t("features.slide2.title") },
        { "@type": "ListItem", "position": 3, "name": t("features.slide3.title") },
        { "@type": "ListItem", "position": 4, "name": t("features.slide4.title") },
      ],
    },
  };

  return (
    <main>
      <SEO
        title={t("seo.features.title")}
        description={t("seo.features.description")}
        path="/features"
        jsonLd={featuresJsonLd}
      />
      <Breadcrumbs
        items={[
          { label: t("nav.home"), path: "/" },
          { label: t("features.title") },
        ]}
      />
      <Flex
        flexDirection={"column"}
        alignItems={"center"}
        p={"20px"}
        gap={"30px"}
      >
        <Text
          as="h1"
          fontSize={"40px"}
          color={"text.dark.grey"}
          fontWeight={"600"}
        >
          {t("features.title")}
        </Text>
        <Features />
      </Flex>
    </main>
  );
}
